<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card
      max-width="500">

        <!-- <v-layout column>
          <v-img :src="require('@/assets/logo.png')"/>
        </v-layout> -->
        <v-list>
          <!-- <v-layout justify-center>
          <v-list-item-content>
            <div class="display-1 pl-5 pt-5">{{ user.firstName }} {{user.lastName }}</div>
          </v-list-item-content>
      </v-layout> -->
          <v-list two-line>
            <v-list-item>
              <v-list-item-action>
                <v-icon x-large color="secondary" style="font-size: 55px;">account_circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="headline">Profile</v-list-item-title>
                <v-list-item-subtitle class="">Contact us at <a href="mailto: support@quber.ca?subject=Update Quber Profile">support@quber.ca</a> to update.</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

             <v-list-item>
              <!-- <v-list-item-action>
                <v-icon color="secondary">account_circle</v-icon>
              </v-list-item-action> -->

              <v-list-item-content>
                <v-list-item-title>{{ user.firstName }} {{ user.lastName }}</v-list-item-title>
                <v-list-item-subtitle>Name</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>

              <v-list-item-content>
                <v-list-item-title>{{ user.mobileNumber }}</v-list-item-title>
                <v-list-item-subtitle>Mobile number</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>

              <v-list-item-content>
                <v-list-item-title>{{ user.quberUserName }}</v-list-item-title>
                <v-list-item-subtitle>Quber username</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>

              <v-list-item-content>
                <v-list-item-title>Created date: {{ user.createdDate }}</v-list-item-title>
                <v-list-item-subtitle>Updated date: {{ user.updatedDate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>

              <v-list-item-content>
                <v-list-item-title>{{ user.referralCode }}</v-list-item-title>
                <v-list-item-subtitle>Referral code</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
   <!-- <v-divider inset></v-divider>

              <v-list-item>
              <v-list-item-action>
                <v-icon color="secondary">fireplace</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ getSubscription }}</v-list-item-title>
                <v-list-item-subtitle>Subscription</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item> -->

          </v-list>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<!-- <template>
  <div class="panel panel-default profile-area">
  <div class="panel-heading"><h3>Profile</h3></div>
  <div class="panel-body">
    <img :src="profile.picture" class="avatar" alt="avatar">
    <div>
      <label><i class="glyphicon glyphicon-user"></i> Nickname</label>
      <h3 class="nickname">{{ profile.nickname }}</h3>
    </div>
    <div>
      <label><i class="glyphicon glyphicon-envelope"></i> Email</label>
      <h3 class="email">{{ profile.email }}</h3>
    </div>
    <pre class="full-profile">{{ profile }}</pre>
  </div>
</div>
</template> -->
<script>
import auth from '@/components/Auth/AuthService'
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
export default {
  // props: ['auth'],
  data: () => ({
    user: null,
    userSubscription: [],
    loadingusers: false
  }),
  created () {
    this.initialize()
  },
  methods: {
    async initialize () {
      // this.loadingUsers = true
      // this.userSearchPanelModel = 0
      // const endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/users/5228`
      // var getResponse = await rh.default.get(endpoint, true).catch(e => {
      //   this.errors.push(e)
      // })
      // this.user = getResponse.data
      this.user = auth.getQuberUser()
    }
  }
  // async getSubscription () {
  //     this.loadingUsers = true
  //     this.userSearchPanelModel = 0
  //     var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_SUBSCRIPTIONS}/subscriptions/user/${this.user.userId}`
  //     var getResponse = await rh.default.get(endpoint, true).catch(e => {
  //       this.errors.push(e)
  //     })

  //     this.userSubscription = getResponse.data
  //     this.loadingUsers = false
  //   }
}
</script>

<style>
.profile-area img {
  max-width: 150px;
  margin-bottom: 20px;
}

.panel-body h3 {
  margin-top: 0;
}
</style>
